import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "kt_modal_add_agent",
  ref: "addAgentModalRef",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  class: "modal-header",
  id: "kt_modal_add_agent_header"
}
const _hoisted_5 = {
  id: "kt_modal_add_agent_close",
  "data-bs-dismiss": "modal",
  class: "btn btn-icon btn-sm btn-active-icon-primary"
}
const _hoisted_6 = { class: "svg-icon svg-icon-1" }
const _hoisted_7 = { class: "modal-body py-10 px-lg-17" }
const _hoisted_8 = {
  class: "scroll-y me-n7 pe-7",
  id: "kt_modal_add_agent_scroll",
  "data-kt-scroll": "true",
  "data-kt-scroll-activate": "{default: false, lg: true}",
  "data-kt-scroll-max-height": "auto",
  "data-kt-scroll-dependencies": "#kt_modal_add_agent_header",
  "data-kt-scroll-wrappers": "#kt_modal_add_agent_scroll",
  "data-kt-scroll-offset": "300px"
}
const _hoisted_9 = { class: "fv-row mb-7" }
const _hoisted_10 = { class: "fv-row mb-7" }
const _hoisted_11 = { class: "fv-row mb-7" }
const _hoisted_12 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_13 = { class: "modal-footer flex-center" }
const _hoisted_14 = ["data-kt-indicator"]
const _hoisted_15 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_16 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_17 = {
  key: 1,
  class: "indicator-progress"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[5] || (_cache[5] = _createElementVNode("h2", { class: "fw-bolder" }, "Add a Agent", -1)),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, [
              _createVNode(_component_inline_svg, {
                src: "/media/icons/duotune/arrows/arr061.svg",
                "aria-hidden": "true"
              })
            ])
          ])
        ]),
        _createVNode(_component_el_form, {
          onSubmit: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
          model: _ctx.formData,
          rules: _ctx.rules,
          ref: "formRef"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _cache[6] || (_cache[6] = _createElementVNode("label", { class: "required fs-6 fw-bold mb-2" }, "Firstname", -1)),
                  _createVNode(_component_el_form_item, { prop: "firstname" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.firstname,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.firstname) = $event)),
                        type: "text",
                        placeholder: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _cache[7] || (_cache[7] = _createElementVNode("label", { class: "required fs-6 fw-bold mb-2" }, "Lastname", -1)),
                  _createVNode(_component_el_form_item, { prop: "lastname" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.lastname,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.lastname) = $event)),
                        type: "text",
                        placeholder: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _cache[8] || (_cache[8] = _createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, [
                    _createElementVNode("span", { class: "required" }, "Email"),
                    _createElementVNode("i", {
                      class: "fas fa-exclamation-circle ms-1 fs-7",
                      "data-bs-toggle": "tooltip",
                      title: "Email address must be active"
                    })
                  ], -1)),
                  _createVNode(_component_el_form_item, { prop: "email" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.email,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.email) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _cache[9] || (_cache[9] = _createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, [
                    _createElementVNode("span", { class: "required" }, "Roles"),
                    _createElementVNode("i", {
                      class: "fas fa-exclamation-circle ms-1 fs-7",
                      "data-bs-toggle": "tooltip",
                      title: "Role of origination"
                    })
                  ], -1)),
                  _createVNode(_component_el_form_item, { prop: "roles" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.formData.country,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.country) = $event)),
                        multiple: ""
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.roleOptions, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.value,
                              label: item.label,
                              value: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _cache[12] || (_cache[12] = _createElementVNode("button", {
                type: "reset",
                id: "kt_modal_add_agent_cancel",
                class: "btn btn-light me-3"
              }, " Discard ", -1)),
              _createElementVNode("button", {
                "data-kt-indicator": _ctx.loading ? 'on' : null,
                class: "btn btn-lg btn-primary",
                type: "submit"
              }, [
                (!_ctx.loading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_15, [
                      _cache[10] || (_cache[10] = _createTextVNode(" Submit ", -1)),
                      _createElementVNode("span", _hoisted_16, [
                        _createVNode(_component_inline_svg, {
                          src: "icons/duotune/arrows/arr064.svg",
                          "aria-hidden": "true"
                        })
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.loading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_17, [...(_cache[11] || (_cache[11] = [
                      _createTextVNode(" Please wait... ", -1),
                      _createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
                    ]))]))
                  : _createCommentVNode("", true)
              ], 8, _hoisted_14)
            ])
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ])
    ])
  ], 512))
}